import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
import moment from "moment";

export const transactionReportListState = atom({
    key: 'transactionReportListState',
    default: [],
})

export const transactionReportCustomerState = atom({
    key: 'transactionReportCustomerState',
    default: {
        data: [],
        ovf: false,
    }
})

export const transactionReportTransactionTypeState = atom({
    key: 'transactionReportTransactionTypeState',
    default: {
        data: [],
        ovf: false,
    }
})

export const transactionReportFromDateState = atom({
    key: 'transactionReportFromDateState',
    default: moment().subtract(1, 'month').format('YYYY-MM-DD'),
})

export const transactionReportToDateState = atom({
    key: 'transactionReportToDateState',
    default: moment().format('YYYY-MM-DD'),
})

export const transactionReportCustomerValueState = atom({
    key: 'transactionReportCustomerValueState',
    default: { label: "All", value: 0 },
})

export const transactionReportTransactionTypeValueState = atom({
    key: 'transactionReportTransactionTypeValueState',
    default: { label: "All", value: "all" },
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const transactionReportFilterState = selector({
    key: 'transactionReportFilterState',
    get: ({ get }) => ([
        {
            label: 'From Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(transactionReportFromDateState),
        },
        {
            label: 'To Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(transactionReportToDateState),
        },
        {
            label: 'Customer',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(transactionReportCustomerValueState),
            list: get(transactionReportCustomerState),
        },
        {
            label: 'Transaction Type',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(transactionReportTransactionTypeValueState),
            list: get(transactionReportTransactionTypeState),
        },
    ]),
    set: ({ set }, e) => {
        if(e.filterLabel === 'From Date'){
            set(transactionReportFromDateState, e.value)
        }
        if(e.filterLabel === 'To Date'){
            set(transactionReportToDateState, e.value)
        }
        if(e.filterLabel === 'Customer'){
            set(transactionReportCustomerValueState, e.value)
        }
        if(e.filterLabel === 'Transaction Type'){
            set(transactionReportTransactionTypeValueState, e.value)
        }
    }
})

export const formModes = {
    view: [ { name: 'Default View' } ],
}

export const transactionReportDataStructureState = selector({
    key: 'transactionReportDataStructureState',
    get: ({ get }) => (
        [
            { 
                label: 'Reference',
                field: 'transaction_number',
                type: 'text',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Customer',
                field: 'customer_name',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            {
                label: 'Vessel',
                field: 'vessel',
                type: 'text',
                order: { table: 2.5, form: 2.5 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            { 
                label: 'Type',
                field: 'transaction_type',
                type: 'text',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            {
                label: 'Permit Duration',
                field: 'permit_type',
                type: 'text',
                order: { table: 3.5, form: 3.5 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
                tableDefault: '-',
            },
            { 
                label: 'Date',
                field: 'transaction_date',
                type: 'date',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Subtotal',
                field: 'subtotal',
                type: 'number',
                order: { table: 5, form: 5 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Tax Amount',
                field: 'tax_amount',
                type: 'number',
                order: { table: 6, form: 6 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Net Amount',
                field: 'net_amount',
                type: 'number',
                order: { table: 7, form: 7 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
